import { Pipe, PipeTransform } from '@angular/core';
import ProductHelper from '../../../helpers/product-helper';

@Pipe({
  name: 'alternativeDisplay'
})
export class AlternativeDisplayPipe implements PipeTransform {
  public transform(value: string, otherPlacementType: string) {
    return ProductHelper.calculatePlacementTypeDisplay(
      value,
      otherPlacementType
    );
  }
}
